/* eslint-disable react/prop-types */
import React from 'react';

interface LoomVideoProps {
    videoId: string;
    title: string;
    onError: (errorMessage: string) => void;
}

const LoomVideo: React.FC<LoomVideoProps> = ({ videoId, title, onError }) => {
    if (!videoId) {
        onError('Loom video ID is empty');
        return null;
    }

    const embedUrl = `https://www.loom.com/embed/${encodeURIComponent(
        videoId
    )}?hide_owner=true`;

    return (
        <div className="component-video__container">
            <iframe
                src={embedUrl}
                title={title}
                allow="fullscreen"
                // fallback for browsers that don't support allow="fullscreen"
                allowFullScreen
                // @ts-ignore - this is a workaround for browsers that don't support allowFullScreen
                mozallowfullscreen="true"
                webkitallowfullscreen="true"
                sandbox="allow-same-origin allow-scripts"
                className="component-video__iframe"
            />
        </div>
    );
};

export default LoomVideo;
